import { FETCH_ALL_USER_ACTIVITY_SUCCESS } from "../ActionTypes";

const INIT_STATE = {
  userActivity: [],
};

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_USER_ACTIVITY_SUCCESS: {
      return {
        ...state,
        userActivity: action.payload.data,
      };
    }
    default:
      return state;
  }
}

export default reducers;
